import { render, staticRenderFns } from "./zhengshu.vue?vue&type=template&id=770da2fe&scoped=true"
import script from "./zhengshu.vue?vue&type=script&lang=js"
export * from "./zhengshu.vue?vue&type=script&lang=js"
import style0 from "./zhengshu.vue?vue&type=style&index=0&id=770da2fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770da2fe",
  null
  
)

export default component.exports